import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Fade } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        width: (props) => `calc(100vw / ${props.projGridWidth} - 10px)`,
        height: (props) => `calc((100vw / ${props.projGridWidth}) / 1.53)`,
        // minWidth: '360px',
        // minHeight: '235px',
        backgroundColor: theme.palette.primary.main,
        background: (props) => `url(${props?.project?.bgImg})`,
        backgroundSize: (props) => 'cover',
        margin: '2px',
        display: 'flex',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    hoverContainer: {
        // minWidth: '360px',
        // minHeight: '235px',

        backgroundColor: 'rgba(13, 13, 13, 0.85)',
        position: 'absolute',
        top: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: (props) => `calc((100vw / ${props.projGridWidth}) / 1.53)`,
        width: (props) => `calc(100vw / ${props.projGridWidth} - 10px)`,
        textDecoration: 'none',
        overflow: 'hidden',
    },
    background: {
        // minWidth: '360px',
        // minHeight: '235px',
        width: (props) => `calc(100vw / ${props.projGridWidth} - 10px)`,
        height: (props) => `calc((100vw / ${props.projGridWidth}) / 1.53)`,

        backgroundColor: theme.palette.primary.main,
        background: (props) => `url(${props?.project?.bgImg})`,

        backgroundSize: (props) => 'cover',
    },
    separator: {
        backgroundColor: theme.palette.common.gold,
        height: '3px',
        width: '30px',
        margin: '10px 0',
    },
    opacity: {
        opacity: 0.2,
    },
    title: {
        fontSize: '2em',
        textAlign: 'center',
        marginBottom: '5px',
        fontWeight: 500,
    },
    subtitle: {
        padding: '0px 2em',
        fontSize: '1.2em',
        textAlign: 'center',
    },
}));

const ProjectComponent = (props) => {
    const { project } = props;
    const classes = useStyles(props);

    const [isHovering, setIsHovering] = useState(false);

    const handleMouseEnter = () => {
        setIsHovering(true);
    };

    const handleMouseLeave = () => {
        setIsHovering(false);
    };

    return (
        <>
            <div
                className={classes.container}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{ position: 'relative' }}
            >
                <div className={classes.background}></div>
                {isHovering && (
                    <Fade
                        in={isHovering}
                        style={{ transitionTimingFunction: 'ease-in' }}
                    >
                        <div
                            className={classes.hoverContainer}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Typography
                                className={classes.title}
                                variant={'h2'}
                            >
                                {/* {project.altTitle ?? project.title} */}
                                {project.title}
                            </Typography>
                            <div className={classes.separator}></div>
                            <Typography
                                className={classes.subtitle}
                                variant={'subtitle2'}
                            >
                                {project.subtitle}
                            </Typography>
                        </div>
                    </Fade>
                )}
            </div>
        </>
    );
};

export default ProjectComponent;
